import React from "react";

const AgentIcon = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16.6509" r="16" fill="#339EEC" fillOpacity="0.3" />
    <path
      d="M23.6137 15.7578H21.1137C20.7822 15.7578 20.4643 15.8895 20.2299 16.1239C19.9954 16.3584 19.8637 16.6763 19.8637 17.0078V20.1328C19.8637 20.4643 19.9954 20.7823 20.2299 21.0167C20.4643 21.2511 20.7822 21.3828 21.1137 21.3828H22.3637C22.6953 21.3828 23.0132 21.2511 23.2476 21.0167C23.482 20.7823 23.6137 20.4643 23.6137 20.1328V15.7578ZM23.6137 15.7578C23.6137 14.7681 23.4179 13.7882 23.0374 12.8746C22.6569 11.9609 22.0994 11.1316 21.3969 10.4344C20.6944 9.73728 19.8609 9.18604 18.9444 8.81251C18.0279 8.43897 17.0465 8.25052 16.0569 8.25803C15.0672 8.25052 14.0858 8.43897 13.1693 8.81251C12.2528 9.18604 11.4193 9.73728 10.7168 10.4344C10.0144 11.1316 9.45683 11.9609 9.07636 12.8746C8.69588 13.7882 8.5 14.7681 8.5 15.7578V20.1328C8.5 20.4643 8.6317 20.7823 8.86612 21.0167C9.10054 21.2511 9.41848 21.3828 9.75 21.3828H11C11.3315 21.3828 11.6495 21.2511 11.8839 21.0167C12.1183 20.7823 12.25 20.4643 12.25 20.1328V17.0078C12.25 16.6763 12.1183 16.3584 11.8839 16.1239C11.6495 15.8895 11.3315 15.7578 11 15.7578H8.5"
      stroke="#339EEC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6137 20.1328V22.0078C23.6137 22.6709 23.3503 23.3067 22.8815 23.7756C22.4127 24.2444 21.7768 24.5078 21.1137 24.5078H16.625"
      stroke="#339EEC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AgentIcon;
